exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Header__root___24fq2 {\n  background: -webkit-gradient(linear, left top, left bottom, from(rgba(0, 0, 0, .33)), to(rgba(0, 0, 0, 0)));\n  background: linear-gradient(rgba(0, 0, 0, .33), rgba(0, 0, 0, 0));\n  color: rgba(255, 255, 255, .9);\n  padding: 10px 10px 20px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n}\n\n.Header__close___1v8YF {\n  margin-left: auto;\n  cursor: pointer;\n  fill: white;\n  height: 32px;\n  width: 32px;\n}\n\n.Header__close___1v8YF:hover {\n  fill: #d6dee7;\n}\n", ""]);

// exports
exports.locals = {
	"root": "Header__root___24fq2",
	"close": "Header__close___1v8YF"
};